import { z } from 'zod';
import { DOCUMENT_SECTIONS, DOCUMENT_SORTS } from '@atnt/shared';

/**
 * URL state of the documents page. Kept apart from `model.ts` so the route config (always in the main bundle)
 * imports only this, while the page itself stays in the route's lazy chunk.
 */

export const DOCUMENT_VIEWS = ['table', 'grid', 'columns'] as const;
export type DocumentView = (typeof DOCUMENT_VIEWS)[number];

/** `/t/:slug/documents?section=&folder=&view=&q=&sort=` (03-modules §1.6: side panels and folders are URL state). */
export const documentsSearchSchema = z.object({
  section: z.enum(DOCUMENT_SECTIONS).optional().catch(undefined),
  folder: z.uuid().optional().catch(undefined),
  view: z.enum(DOCUMENT_VIEWS).optional().catch(undefined),
  q: z.string().max(200).optional().catch(undefined),
  sort: z.enum(DOCUMENT_SORTS).optional().catch(undefined),
});
export type DocumentsSearch = z.infer<typeof documentsSearchSchema>;
